import { useState, useRef } from "react";

import dictionary from "../../assets/images/dictionary.png";
import translate from "../../assets/images/translate.png";

import "./style.css";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import Translator from "./Translator";

import { WaveSkeletonLoader } from "../loader";

function HelperComponent() {
  const [showDictionary, setShowDictionary] = useState(false);
  const [word, setWord] = useState("");
  const [definition, setDefinition] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { auth, setCommonWarning } = useAuth();
  const dicInputRef = useRef(null);

  const [showTranslate, setShowTranslate] = useState(false);

  const searchWord = async (input) => {
    try {
      // console.log(input.current.value);
      const word = input.current.value;
      if (!word) return;
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}entrytoken`,
        {
          token: auth.token,
          ques: word,
        }
      );
      const resData = res.data;
      if (resData.status === 200) {
        setDefinition(resData.message);
        setWord(word);
      } else if (resData.status === 401) {
        navigate("/login");
        console.error("Error fetching data:", resData.message);
      } else if (resData.status === 400) {
        console.log("Error fetching data:", resData.message);
        setCommonWarning(resData.message);
      } else if (resData.status === 500) {
        console.error("Error fetching data:", resData.message);
        setCommonWarning(resData.error.message);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="helper-wrapper">
        <div className="helper">
          <div
            className="dictionary"
            onClick={() => {
              setShowDictionary(true);
              setWord("");
              setDefinition("");
            }}
            data-tooltip="Open Dictionary"
          >
            <img src={dictionary} alt="Dictionary" />
          </div>

          <div
            className="translate"
            onClick={() => setShowTranslate(true)}
            data-tooltip="Open Translator"
          >
            <img src={translate} alt="Translate" />
          </div>
        </div>

        {showDictionary && (
          <div className="dictionary-overlay">
            <div className="dictionary-popup">
              <button
                className="close-btn"
                onClick={() => setShowDictionary(false)}
              >
                ✖
              </button>
              <h2>Dictionary</h2>
              <p>What would you like to search or know about?</p>

              <div className="search-box">
                <input
                  type="text"
                  ref={dicInputRef}
                  placeholder="Type a word..."
                />
                <button onClick={(e) => searchWord(dicInputRef)}>Search</button>
              </div>

              <div className="results">
                <div className="result-item">
                  <p className="label">Word:</p>
                  <p className="value">
                    {loading ? (
                      <>
                        <WaveSkeletonLoader width="300px" height="20px" />
                      </>
                    ) : word ? (
                      word
                    ) : (
                      "Type a word "
                    )}
                  </p>
                </div>

                <div className="result-item">
                  <p className="label">Meaning:</p>
                  <p className="value">
                    {loading ? (
                      <>
                        <WaveSkeletonLoader width="300px" height="20px" />
                        <WaveSkeletonLoader
                          width="250px"
                          height="20px"
                          style={{ marginTop: "5px" }}
                        />
                        <WaveSkeletonLoader
                          width="280px"
                          height="20px"
                          style={{ marginTop: "5px" }}
                        />
                      </>
                    ) : definition ? (
                      definition
                    ) : (
                      "Type a word and click search to see the meaning here."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {showTranslate && <Translator setShowTranslate={setShowTranslate} />}
      </div>
    </>
  );
}

export default HelperComponent;
